import { AutoCompleteStyled, StyledTextField } from "./styled-components/AddressFields";
import { nationalities } from "./utils/nationalities";
import { AutocompleteRenderInputParams } from "@mui/material";
import { Field, useFormikContext } from "formik";
import { StyledEndAdorment } from "./AddressLookup";
import { FormValues } from "./utils/formSchema";
import { useAppDispatch } from "src/store/store";
import { setNationality } from "src/store/features/onboarding.slice";

export const NationalityField = () => {
  const dispatch = useAppDispatch();
  const { setFieldValue, setFieldError } = useFormikContext();
  const {
    values: { nationality },
    errors: { nationality: nationalityErrorMessage },
  } = useFormikContext<FormValues>();

  return (
    <>
      <AutoCompleteStyled
        options={nationalities}
        selected={!!nationality && !nationalityErrorMessage}
        value={nationality}
        onInputChange={(event, newValue) => {
          const userInput = newValue.trim();
          if (userInput && nationalities.includes(userInput)) {
            setFieldValue("nationality", userInput);
            dispatch(setNationality(userInput));
            setFieldError("nationality", "");
          } else {
            setFieldError("nationality", "Invalid nationality selected");
          }
        }}
        renderInput={(params: AutocompleteRenderInputParams) => (
          <Field
            {...params}
            as={StyledTextField}
            name="nationality"
            error={!!nationalityErrorMessage}
            helperText={nationalityErrorMessage}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <StyledEndAdorment selected={!!nationality && !nationalityErrorMessage} />
              ),
              "data-testid": "nationality-field-input",
            }}
            InputLabelProps={{
              ...params.InputLabelProps,
            }}
          />
        )}
      />
    </>
  );
};
